/**
 * Icônes partagées du chrome v2 (header + footer).
 *
 * Déplacées telles quelles depuis HomeV2.jsx lors de l'extraction du
 * header/footer en composants partagés : mêmes SVG, mêmes valeurs par
 * défaut, aucune réécriture — le rendu de la home est inchangé.
 *
 * HomeV2 réimporte celles dont son corps de page se sert encore
 * (`S`, IconScale, IconShield, LiveDot) au lieu d'en garder une copie.
 */
import React from 'react';

/** Attributs communs à tous les SVG de la référence. */
export const S = { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round' };

export const IconScale = ({ size = 15, stroke = '#1a56db', width = 2, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} style={style} {...S}>
    <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" /><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" /><path d="M7 21h10" /><path d="M12 3v18" /><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
  </svg>
);
export const IconChevron = ({ size = 12, stroke = '#9ca3af', width = 2.4, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} style={style} {...S}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
export const IconShield = ({ size = 13, stroke = '#1a56db', width = 2.2, check = false, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} style={style} {...S}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />{check && <path d="m9 12 2 2 4-4" />}
  </svg>
);
export const IconInfo = ({ size = 13, stroke = 'currentColor', width = 2, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} style={style} {...S}>
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
export const IconLock = ({ size = 14, stroke = '#93c5fd', width = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} {...S}>
    <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
export const IconBadgeCheck = ({ size = 14, stroke = '#fbbf24', width = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={stroke} strokeWidth={width} {...S}>
    <circle cx="12" cy="12" r="10" /><polyline points="16 9.5 10.5 15 8 12.5" />
  </svg>
);

export const LiveDot = ({ size = 7, delay }) => (
  <span style={{
    width: size, height: size, borderRadius: '50%', background: '#16a34a',
    animation: `hv2LiveDot 1.6s infinite${delay ? ` ${delay}` : ''}`,
  }} />
);
